export default {
  props:['data'],
  render(){
    const data = this.data || {}
    return <div class="license-stats">
      <div style="width:100%;margin:auto;">
        <div class="panel flex" style="padding:32px 0;">
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#2446FA;font-size: 1.8em; margin-bottom: .6em;"><span>{data.scoreTotal || 0}</span>分</div>
            <div class="label" style="font-size:1.2em;">证照总分</div>
          </div>
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#FEC01A;font-size: 1.8em; margin-bottom: .6em;"><span>{data.actScore || 0}</span>分</div>
            <div class="label" style="font-size:1.2em;">已扣分数</div>
          </div>
          <div class="item" style="flex: auto;text-align:center;">
            <div class="point" style="color:#F02323;font-size: 1.8em; margin-bottom: .6em;"><span>{data.actNum || 0}</span>次</div>
            <div class="label" style="font-size:1.2em;">违法次数</div>
          </div>
        </div>
        <sl-img style="width:100%;height:auto;" src={data.imgPath} public={true} />
      </div>
    </div>
  }
}